import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import createSagaMiddleWare from 'redux-saga';

import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import authSettings from './config/authSettings';

import App from './App';
import history from './store/history';
import getStore from './store/store';
import sagas from './sagas';

// import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';

const msalInstance = new PublicClientApplication(authSettings);
const sagaMiddleWare = createSagaMiddleWare();
const store = getStore(history, sagaMiddleWare);
sagaMiddleWare.run(sagas);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <MsalProvider instance={msalInstance}>
            <Provider store={store}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </Provider>
        </MsalProvider>
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
unregister();